const getEmptyListMessage = (entitiesName: string) => `There are no ${entitiesName} `;
const getEmptyScheduleListMessage = (entitiesName: string) => `You haven't added any ${entitiesName} yet`;
const getEmptyFiltersResultMessage = (entitiesName: string) => `You currently do not have any ${entitiesName ? entitiesName : `talent requests`}`;

export {
  getEmptyListMessage,
  getEmptyFiltersResultMessage,
  getEmptyScheduleListMessage
};